import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MessageDebugPayload {
    messageKey: string;
    chatId: string;
}

export interface MessageDebugState {
    isOpen: boolean;
    messageKey: string | null;
    chatId: string | null;
}

const initialState: MessageDebugState = {
    isOpen: false,
    messageKey: null,
    chatId: null,
};

export const messageDebugSlice = createSlice({
    name: 'messageDebug',
    initialState,
    reducers: {
        openMessageDebug: (state, action: PayloadAction<MessageDebugPayload>) => {
            state.isOpen = true;
            state.messageKey = action.payload.messageKey;
            state.chatId = action.payload.chatId;
        },
        closeMessageDebug: (state) => {
            state.isOpen = false;
            state.messageKey = null;
            state.chatId = null;
        },
    },
});

export const { openMessageDebug, closeMessageDebug } = messageDebugSlice.actions;

export default messageDebugSlice.reducer;

// Selectors
export const selectIsMessageDebugOpen = (state: any) => state.MessageDebugReducer?.isOpen ?? false;
export const selectMessageDebugKey = (state: any) => state.MessageDebugReducer?.messageKey ?? null;
export const selectMessageDebugChatId = (state: any) => state.MessageDebugReducer?.chatId ?? null;
